import { btnHtml, ribbonHtml } from "./kit";

export interface DialogOptions { title: string; body: string; confirm: string; cancel?: string; danger?: boolean }

/**
 * Modal confirm (kit additions: `.scrim` + `.panel.dialog`, mockup 12): a navy scrim, a parchment dialog with the
 * ribbon title pulled up over its edge, one line of copy and a two-button grid. Resolves true on confirm. Tapping the
 * scrim cancels. A `danger` confirm (ERASE, QUIT) is the red destructive button, like Salvage — never the gold "go" one.
 */
export function showDialog(parent: HTMLElement, o: DialogOptions): Promise<boolean> {
  return new Promise((resolve) => {
    const scrim = document.createElement("div");
    scrim.className = "scrim";
    scrim.innerHTML = `<div class="panel dialog">${ribbonHtml(o.title, o.danger ? "red" : "", "dtitle disp")}<p>${o.body}</p><div class="row two">${btnHtml(o.cancel ?? "CANCEL", "dark", { className: "cancel disp" })}${btnHtml(o.confirm, o.danger ? "danger" : "blue", { className: "ok disp accent" })}</div></div>`;
    const done = (v: boolean) => { scrim.remove(); resolve(v); };
    scrim.querySelector<HTMLButtonElement>(".cancel")!.onclick = () => done(false);
    scrim.querySelector<HTMLButtonElement>(".ok")!.onclick = () => done(true);
    scrim.onclick = (e) => { if (e.target === scrim) done(false); };
    parent.append(scrim);
  });
}

/** A "nothing here" panel: the painted roundel for the tab and a one-line caption (drop 2 §6). */
export function emptyStateHtml(imageUrl: string, caption: string): string {
  return `<div class="empty"><img decoding="sync" src="${imageUrl}" alt=""><small>${caption}</small></div>`;
}
